import { render, staticRenderFns } from "./EnquiryListItem.vue?vue&type=template&id=04f1ce70&scoped=true&"
import script from "./EnquiryListItem.vue?vue&type=script&lang=js&"
export * from "./EnquiryListItem.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryListItem.vue?vue&type=style&index=0&id=04f1ce70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f1ce70",
  null
  
)

export default component.exports